export default __webpack_public_path__ + "static/button_b.5c44f3eaf19e60d7a16709373bd91699.png";